import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-expired-link',
  templateUrl: './expired-link.component.html',
  styleUrls: ['./expired-link.component.scss']
})
export class ExpiredLinkComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  login() {
    this.router.navigateByUrl('/auth');
  }
}
